import React from "react";

export default function Progress() {

  return (
    <span><i className="fa fa-spinner fa-spin"/> Carregando</span>
  )

}